var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main",attrs:{"data-app":"true"}},[_c('div',{staticClass:"fallback padding-iframe"},[_c('h2',[_vm._v("Version info:")]),_c('vue-json-pretty',{attrs:{"path":'res',"data":_vm.fetchVersion}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }